import config from "../config/config";
import axios from "axios";
import { getToken } from "../common";

// the company form's Next: saves the details before the terms are accepted
export const saveEventCompany = async ({ auctionId, company, ipAddress }) => {
  return await axios({
    method: "put",
    url: `${config.api.base_url}events/${auctionId}/company`,
    data: { ipAddress, company },
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default saveEventCompany;
